// extracted by mini-css-extract-plugin
export var active = "_ek-2";
export var recordingDot = "_ek-1";
export var recordingIndicator = "_ek-0";